import { Controller } from "@hotwired/stimulus"

// Custom link with this ID is added in OneTrust banner template
const PREFERENCES_LINK_ID = "js-onetrust-preferences"

export default class ConsentBannerController extends Controller {
  openPreferencesFromBanner(e: Event): void {
    const { id } = e.target as HTMLElement

    if (id === PREFERENCES_LINK_ID) {
      // Link in OT template has `href="#"`, so prevent scrolling to top of page
      e.preventDefault()
      this.openPreferences()
    }
  }

  openPreferences(): void {
    window.OneTrust?.ToggleInfoDisplay()
  }
}
